import axios from 'axios';
import getAPIResponsePrivate from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

export const DashboardService = {
  // User home dashboard
  getNewsCarousel: async () => {
    return await getAPIResponsePrivate('/v1/news/carousel', {}, 'GET');
  },

  getLatestBlogPosts: async (forceRefresh = false) => {
    const CACHE_KEY = 'aszende_blog_posts_cache';
    const CACHE_TIME_KEY = 'aszende_blog_posts_cache_time';
    const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;

    if (!forceRefresh) {
      try {
        const cachedTime = localStorage.getItem(CACHE_TIME_KEY);
        const cachedData = localStorage.getItem(CACHE_KEY);

        if (cachedTime && cachedData && Date.now() - parseInt(cachedTime, 10) < TWENTY_FOUR_HOURS) {
          const parsed = JSON.parse(cachedData);
          if (parsed?.data && parsed.data.length > 0) {
            return parsed;
          }
        }
      } catch (e) {
        // Ignore localStorage parse errors
      }
    }

    const endpoint = forceRefresh ? '/v1/blog-posts/latest?refresh=1' : '/v1/blog-posts/latest';
    const res = await getAPIResponsePrivate(endpoint, {}, 'GET');

    if (res?.data && Array.isArray(res.data) && res.data.length > 0) {
      try {
        localStorage.setItem(CACHE_KEY, JSON.stringify(res));
        localStorage.setItem(CACHE_TIME_KEY, Date.now().toString());
      } catch (e) {
        // Ignore storage quota errors
      }
    }

    return res;
  },

  getUserShortcuts: async () => {
    return await getAPIResponsePrivate('/v1/user/me/shortcuts', {}, 'GET');
  },

  saveUserShortcuts: async (shortcuts) => {
    return await getAPIResponsePrivate('/v1/user/me/shortcuts', { shortcuts }, 'POST');
  },

  getLatestHires: async () => {
    return await getAPIResponsePrivate('/v1/dashboard/latest-hires', {}, 'GET');
  },

  getBirthdays: async () => {
    return await getAPIResponsePrivate('/v1/dashboard/birthdays', {}, 'GET');
  },

  // Admin News
  getAdminNewsList: async (params = {}) => {
    return await getAPIResponsePrivate('/v1/news', params, 'GET');
  },

  createNews: async (data) => {
    return await getAPIResponsePrivate('/v1/news', data, 'POST');
  },

  updateNews: async (id, data) => {
    return await getAPIResponsePrivate(`/v1/news/${id}`, data, 'PATCH');
  },

  deleteNews: async (id) => {
    return await getAPIResponsePrivate(`/v1/news/${id}`, {}, 'DELETE');
  },

  uploadNewsImage: async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    const token = localStorage.getItem(process.env.REACT_APP_TOKEN_NAME);
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/v1/news/upload-image`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },
};
